import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaShoppingCart, FaCoins, FaGift } from "react-icons/fa";

const EarnRewards = () => {
  return (
    <Container className="py-5">
      {/* Section Header */}
      <div className="text-center mb-5">
        <h2 className="fw-bold">Earn Rewards</h2>
        <p className="text-muted">
          Shop more on {process.env.REACT_APP_NAME} and earn exciting rewards every time
        </p>
      </div>

      <Row className="g-4">
        {/* Step 1 */}
        <Col md={4}>
          <Card className="h-100 border-0 shadow-sm text-center">
            <Card.Body className="p-4">
              <FaShoppingCart className="fs-1 text-primary mb-3" />
              <h5 className="fw-bold">Place an Order</h5>
              <p className="text-muted">
                Buy your favorite products from {process.env.REACT_APP_NAME} using Cash on Delivery
                or Online Payment.
              </p>
            </Card.Body>
          </Card>
        </Col>

        {/* Step 2 */}
        <Col md={4}>
          <Card className="h-100 border-0 shadow-sm text-center">
            <Card.Body className="p-4">
              <FaCoins className="fs-1 text-success mb-3" />
              <h5 className="fw-bold">Earn Reward Points</h5>
              <p className="text-muted">
                Get reward points for every successful order you complete.
                More shopping means more rewards.
              </p>
            </Card.Body>
          </Card>
        </Col>

        {/* Step 3 */}
        <Col md={4}>
          <Card className="h-100 border-0 shadow-sm text-center">
            <Card.Body className="p-4">
              <FaGift className="fs-1 text-warning mb-3" />
              <h5 className="fw-bold">Redeem Rewards</h5>
              <p className="text-muted">
                Use your reward points to get discounts, special offers, and
                exclusive deals on {process.env.REACT_APP_NAME}.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default EarnRewards;
